import React from "react";

const BonusesIcon = (props) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g
				clip-path="url(#clip0_4963_293644)"
				{...props}>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M19.7107 14.013V21.2332C19.7107 21.6667 19.3744 22 18.9376 22H13.561V14.013H19.7107ZM10.4385 14.013V22H5.04169C4.62507 22 4.26811 21.6667 4.26811 21.2332V14.013H10.4385ZM10.4785 6.63393V11.4287H3.61384C3.27758 11.4287 3 11.1726 3 10.8398V7.24384C3 6.90907 3.27758 6.63393 3.61384 6.63393H10.4785ZM20.3852 6.63393C20.7224 6.63393 21 6.90907 21 7.24384V10.8398C21 11.1726 20.7224 11.4287 20.3852 11.4287H13.6004V6.63393H20.3852ZM12.8493 3.29559C15.1139 1.2777 18.6746 1.74784 18.4523 3.80189C18.2314 5.83835 13.9932 5.61355 12.2227 5.4293C12.8227 5.1781 13.2324 4.70552 13.2324 4.15719C13.2324 3.83415 13.0875 3.53799 12.8493 3.29559ZM5.5475 3.80189C5.32514 1.74784 8.88639 1.2777 11.1504 3.29559C10.9123 3.53799 10.7673 3.83415 10.7673 4.15719C10.7673 4.70552 11.1771 5.1781 11.7771 5.4293C10.0066 5.61355 5.76838 5.83835 5.5475 3.80189Z"
					fill="#EFF0F6"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4963_293644">
					<rect
						width="18"
						height="20"
						fill="white"
						transform="translate(3 2)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default BonusesIcon;
